import Main from '@/components/main'
import parentView from '@/components/parent-view'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true
    },
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/',
    name: '_home',
    redirect: '/home',
    component: Main,
    meta: {
      hideInMenu: false,
      notCache: true
    },
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          hideInMenu: false,
          title: '首页',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/home/home')
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/login/login.vue')
  },
  // 用户管理
  {
    path: '/user',
    name: 'user',
    redirect: '/user/user-manage',
    meta: {
      title: '用户管理',
      icon: 'ios-person'
    },
    component: Main,
    children: [
      {
        path: 'user-manage',
        name: 'user-namage',
        meta: {
          title: '用户管理',
          icon: 'ios-person'
        },
        component: () => import('@/view/user-manage/user-manage')
      }
    ]
  },
  // 内容管理
  {
    path: '/article',
    name: 'article',
    meta: {
      title: '内容管理',
      icon: 'ios-book-outline'
    },
    component: Main,
    children: [
      {
        path: 'article-category',
        name: 'article-category',
        meta: {
          title: '文章分类',
          icon: 'ios-bookmarks-outline'
        },
        component: () => import('@/view/article-manage/category/category-list')
      },
      {
        path: 'article-list',
        name: 'article-list',
        meta: {
          title: '文章列表',
          icon: 'ios-list'
        },
        component: parentView,
        children: [
          {
            path: '',
            name: 'article-list',
            meta: {
              title: '文章列表',
              hideInBread: true,
              icon: 'ios-list'
            },
            component: () => import('@/view/article-manage/article/article-list')
          },
          {
            path: 'add-article',
            name: 'add-article',
            meta: {
              activeName: 'article-list',
              title: '添加文章',
              icon: 'ios-add',
              hideInMenu: true
            },
            component: () => import('@/view/article-manage/article/add-article')
          }
        ]
      }
    ]
  },
  // 会员单位
  {
    path: '/member',
    name: 'member',
    redirect: '/member/member-manage',
    meta: {
      title: '会员单位',
      icon: 'ios-people'
    },
    component: Main,
    children: [
      {
        path: 'member-manage',
        name: 'member-namage',
        meta: {
          title: '会员单位',
          icon: 'ios-people',
          activeName: 'member',
        },
        component: () => import('@/view/member-manage/member-manage')
      }
    ]
  },
  // 活动管理
  {
    path: '/activity',
    name: 'activity',
    meta: {
      title: '活动管理',
      icon: 'ios-albums-outline'
    },
    component: Main,
    children: [
      {
        path: 'competition-list',
        name: 'competition-list',
        meta: {
          title: '赛事列表',
          icon: 'ios-list'
        },
        component: parentView,
        children: [
          {
            path: '',
            name: 'competition-list',
            meta: {
              title: '赛事列表',
              icon: 'ios-list'
            },
            component: () => import('@/view/activity-manage/competition/competition-list')
          },
          {
            path: 'add-competition',
            name: 'add-competition',
            meta: {
              activeName: 'competition-list',
              title: '添加赛事',
              icon: 'ios-add',
              hideInMenu: true
            },
            component: () => import('@/view/activity-manage/competition/add-competition')
          },
          {
            path: 'competition-signup-list',
            name: 'competition-signup-list',
            meta: {
              activeName: 'competition-list',
              title: '报名列表',
              icon: 'ios-add',
              hideInMenu: true
            },
            component: () => import('@/view/activity-manage/competition/signup/signup-list')
          }
        ]
      },
      {
        path: 'activity-list',
        name: 'activity-list',
        meta: {
          title: '活动列表',
          icon: 'ios-list'
        },
        component: parentView,
        children: [
          {
            path: '',
            name: 'activity-list',
            meta: {
              title: '活动列表',
              hideInBread: true,
              icon: 'ios-list'
            },
            component: () => import('@/view/activity-manage/activity/activity-list')
          },
          {
            path: 'add-activity',
            name: 'add-activity',
            meta: {
              activeName: 'activity-list',
              title: '添加活动',
              icon: 'ios-add',
              hideInMenu: true
            },
            component: () => import('@/view/activity-manage/activity/add-activity')
          },
          {
            path: 'activity-signup-list',
            name: 'activity-signup-list',
            meta: {
              activeName: 'activity-list',
              title: '报名列表',
              icon: 'ios-add',
              hideInMenu: true
            },
            component: () => import('@/view/activity-manage/activity/signup/signup-list')
          }
        ]
      }
    ]
  },
  {
    path: '/license',
    name: 'license',
    meta: {
      icon: 'ios-albums',
      title: '证书管理'
    },
    component: Main,
    children: [
      {
        path: 'license-record',
        name: 'license-record',
        meta: {
          title: '发放记录',
          icon: 'ios-list'
        },
        component: parentView,
        children: [
          {
            path: '',
            name: 'license-record',
            meta: {
              title: '发放记录',
              icon: 'ios-list',
              hideInBread: true
            },
            component: () => import('@/view/license-manage/record/record-list')
          }
        ]
      },
      {
        path: 'license-list',
        name: 'license-list',
        meta: {
          title: '证书管理',
          icon: 'ios-list'
        },
        component: parentView,
        children: [
          {
            path: '',
            name: 'license-list',
            meta: {
              title: '证书管理',
              icon: 'ios-list',
              hideInBread: true
            },
            component: () => import('@/view/license-manage/license/license-list')
          },
          {
            path: 'license-template',
            name: 'license-template',
            meta: {
              title: '证书模板',
              icon: 'ios-list',
              hideInBread: true,
              activeName:'license-list',
              hideInMenu: true
            },
            component: () => import('@/view/license-manage/license/license-template')
          }
        ]
      }
    ]
  },
  // 页面设计
  {
    path: '/devise',
    name: 'devise',
    redirect: '/devise/devise-page',
    meta: {
      title: '页面设计',
      icon: 'ios-brush'
    },
    component: Main,
    children: [
      {
        path: 'devise-page',
        name: 'devise-page',
        meta: {
          title: '页面设计',
          icon: 'ios-brush',
          activeName:'devise',
        },
        component: () => import('@/view/devise-page/index')
      }
    ]
  },

  // 管理员管理
  {
    path: '/permission',
    name: 'permission',
    meta: {
      title: '权限管理',
      icon: 'md-person'
    },
    component: Main,
    children: [
      {
        path: 'permission-manage',
        name: 'permission-manage',
        meta: {
          title: '权限列表'
        },
        component: () => import('@/view/permission/permission-manage/permission-manage')
      },
      {
        path: 'add-permission',
        name: 'add-permission',
        meta: {
          title: '添加菜单',
          hideInMenu: true,
          activeName: 'permission-manage'
        },
        component: () => import('@/view/permission/permission-manage/add-permission')
      },
      {
        path: 'admin-manage',
        name: 'admin-manage',
        meta: {
          title: '管理员列表'
        },
        component: () => import('@/view/permission/admin-manage/admin-manage')
      },
      {
        path: 'add-admin',
        name: 'add-admin',
        meta: {
          title: '添加管理员',
          hideInMenu: true,
          activeName: 'admin-manage'
        },
        component: () => import('@/view/permission/admin-manage/add-admin')
      },
      {
        path: 'role-manage',
        name: 'role-manage',
        meta: {
          title: '角色列表'
        },
        component: () => import('@/view/permission/role-manage/role-manage')
      },
    ]
  },
  {
    path: '/403',
    name: 'error_403',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/403.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/500.vue')
  },
  {
    path: '*',
    name: 'error_403',
    meta: {
      hideInMenu: true,
    },
    component: () => import('@/view/error-page/403.vue'),
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/404.vue')
  }
]
